import { render, staticRenderFns } from "./add-research-site-document.vue?vue&type=template&id=0c281ea1&scoped=true&"
import script from "./add-research-site-document.vue?vue&type=script&lang=js&"
export * from "./add-research-site-document.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=0c281ea1&scoped=true&lang=scss&"
import style1 from "./add-research-site-document.vue?vue&type=style&index=1&id=0c281ea1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c281ea1",
  null
  
)

component.options.__file = "add-research-site-document.vue"
export default component.exports